// extracted by mini-css-extract-plugin
export var label = "_3u-1";
export var reminder = "_3u-0";